import { render, staticRenderFns } from "./ListagemCupons.vue?vue&type=template&id=4f693e80"
import script from "./ListagemCupons.vue?vue&type=script&lang=js"
export * from "./ListagemCupons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports